import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import QRGenerator from './Components/QRC/qrcode';



function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<QRGenerator />} />

      </Routes>
    </Router>
  );
}

export default App;

